/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsFilter extends models.AppSecopsDashboardRequestBase {
    getFixupPrototypeFunction() { return AppSecopsFilter.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsFilter>): AppSecopsFilter {
        let obj = Object.assign(new AppSecopsFilter(), model);
        AppSecopsFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsFilter>): AppSecopsFilter {
        if (!model) return null;
        return AppSecopsFilter.newInstance(<AppSecopsFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsFilter) {
        if (!obj) return;

        models.AppSecopsFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsFilter): boolean {
        if (models.AppSecopsDashboardRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Query based on Tenant ID, Application ID, Portfolio ID, Project ID and SBOM references
     */
    filters: models.QueryOperator;

}
